import { render, staticRenderFns } from "./withdrawRecord.vue?vue&type=template&id=55206ce9&scoped=true"
import script from "./withdrawRecord.vue?vue&type=script&lang=js"
export * from "./withdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./withdrawRecord.vue?vue&type=style&index=0&id=55206ce9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55206ce9",
  null
  
)

export default component.exports